import { render } from "./DocumentAction.vue?vue&type=template&id=560c10a7&scoped=true&ts=true"
import script from "./DocumentAction.vue?vue&type=script&lang=ts"
export * from "./DocumentAction.vue?vue&type=script&lang=ts"

import "./DocumentAction.vue?vue&type=style&index=0&id=560c10a7&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560c10a7"]])

export default __exports__